import { Checkbox, Col, DatePicker, Select, Input, Row, Button, Modal } from "antd";
import { ExclamationCircleFilled, PlusOutlined } from '@ant-design/icons';
import AdminModal from "./AdminModal";
import PreviewImgModal from './Media/PreviewImgModal';
import dayjs from 'dayjs'
import { useState } from "react";
import { useEffect } from "react";
import axios from 'axios';
import TextArea from "antd/es/input/TextArea";
const { confirm } = Modal;

const AdminTeacherAddCourseModal = (props) => {
    const [check, setCheck] = useState(false);
    return (<>
        <Modal
            // width={'auto'}
            style={{ pointerEvents: 'auto' }}
            open={props.open}
            bodyStyle={{ backgroundColor: props.edit ? '#faf6f5' : '##FCF5F6' }}
            width={450}
            footer={false}
            data={props.data}
            className="modalStyle2"
            wrapClassName={"modalStyle2"}
            modalRender={(e) => <>
                <div style={{ backgroundColor: props.edit ? '#faf6f5' : '#FCF5F6', padding: '20px', borderTop: `solid #${props.color} 5px ` }}>
                    <Row gutter={[10, 10]} >
                        <Col span={24}>
                            <Row justify="space-between" align={'bottom'}>
                                {props.edit ?
                                    <>
                                        <img style={{ position: 'relative' }} width="35%" height="35%" src='/cram_school/edit.png'></img>
                                    </> :
                                    <>
                                        <img style={{ position: 'relative' }} width="35%" height="35%" src='/cram_school/add.png'></img>
                                    </>}
                                <Col style={{ fontWeight: 'bold', fontSize: '20px', position: 'absolute', zIndex: 99, top: 55, left: 32 }} >{props.title}</Col>
                                <Col>
                                </Col>
                            </Row>
                        </Col>
                        <Col span={24}>
                            <Row gutter={[8, 8]} align={'middle'}>
                                <Col span={6}>課程名稱</Col>
                                <Col span={18}>
                                    <Select style={{ width: '100%' }}>

                                    </Select>
                                </Col>
                                <Col span={6}>補課時間</Col>
                                <Col span={18}>
                                    <DatePicker style={{ width: '100%' }}></DatePicker>
                                </Col>
                                <Col span={6}>補課原因</Col>
                                <Col span={18}>
                                    <TextArea rows={3}></TextArea>
                                </Col>
                                <Col span={6}>代課老師</Col>
                                <Col span={18}>
                                    <Checkbox checked={check} onChange={e => setCheck(!check)}>是</Checkbox>
                                    {check ? <Select style={{ width: 150 }}></Select> : null}
                                </Col>
                                <Col span={6}>上課教室</Col>
                                <Col span={18}>
                                    <Select style={{ width: 150 }}></Select>
                                </Col>
                            </Row>
                        </Col>
                        <Col span={24}>
                            <Row gutter={[10, 10]} justify={"center"}>
                                <Col>
                                    <Button size='large' style={{ background: '#4a4a4a', color: '#ffffff' }} onClick={(e) => props.setOpen(false)} block>取消</Button>
                                </Col>
                                <Col >
                                    <Button
                                        onClick={e => { props.edit ? props.handleEdit() : props.handleSubmit() }}
                                        size='large' style={{ background: props.edit ? `#${props.color}` : 'rgba(232, 79, 117, 1)', color: '#ffffff' }} block>{props.edit ? '修改' : '送出'}</Button>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div >
            </>}
            centered
        >
        </Modal >
    </>)

}
export default AdminTeacherAddCourseModal;